import { getIsAdultDesignsVerboten } from '@/model/productType/getIsAdultDesignsVerboten';
import { getProductType } from '@/redux/draft/getters/getProductType';
import { StoreState } from '@/redux/types';

export const selectIsAdultDesignsVerboten = (state: StoreState) =>
  getIsAdultDesignsVerboten(getProductType(state));
